import React from 'react';
import {Route} from 'react-router-dom';
import CurrentList from './event-list';
import UpcomingList from './upcmoing-event-list'
import EventDetail from './event-detail'
import ExhibitionEdit from '../Admin/Exhibition/edit-exhibition'



function Event(){
    return(
        <div className='flex_event'>
        <div className='eventLeft'>
        <Route path='/events/current/list/:tag'><CurrentList/></Route>
        <Route path='/events/upcoming/list/:tag'><UpcomingList/></Route>
        </div>

        <div className='eventRight'>
         <Route path='/events/current/list/all/detail/:id'><EventDetail/></Route> 
         <Route path='/events/current/list/isFreeAdmission/detail/:id'><EventDetail/></Route> 
         <Route path='/events/current/list/isRecommendation/detail/:id'><EventDetail/></Route> 
         <Route path='/events/current/list/cancel/detail/:id'><EventDetail/></Route> 
         <Route path='/events/current/list/postponed/detail/:id'><EventDetail/></Route> 
         <Route path='/events/current/list/digital/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/all/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/isFreeAdmission/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/isRecommendation/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/cancel/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/postponed/detail/:id'><EventDetail/></Route> 
         <Route path='/events/upcoming/list/digital/detail/:id'><EventDetail/></Route> 
        </div>
    </div>
    )
}

export default Event;